import moment from 'moment-timezone';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DebugFieldComponent, DebugItemsComponent, DebugSizeComponent } from '../../ui';
import { RestaurantTableService } from '../../../../services';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'core-debug-table',
  templateUrl: './debug-table.component.html',
  styleUrls: ['./debug-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DebugSizeComponent,
    DebugItemsComponent,
    DebugFieldComponent,
    UpperCasePipe,
  ]
})
export class DebugTableComponent {
  private readonly restaurantTable = inject(RestaurantTableService);


  public readonly table = toSignal(this.restaurantTable.table$);

  public dayName(day: number): string {
    return moment().weekday(day).format('dddd');
  }

}
